import React, { useEffect, useMemo, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

import st from './StyledQr.module.css';

export function StyledQr({ url, size = 220, className }) {
  const containerRef = useRef(null);

  const qr = useMemo(() => {
    return new QRCodeStyling({
      width: size,
      height: size,
      type: 'svg',
      data: url,
      margin: 8,
      qrOptions: {
        errorCorrectionLevel: 'H',
      },
      backgroundOptions: {
        color: 'transparent',
      },
      dotsOptions: {
        type: 'rounded',
        gradient: {
          type: 'linear',
          rotation: 0,
          colorStops: [
            { offset: 0, color: 'rgba(50, 255, 126, 0.95)' },
            { offset: 1, color: 'rgba(255, 77, 77, 0.92)' },
          ],
        },
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: 'rgba(232, 236, 244, 0.92)',
      },
      cornersDotOptions: {
        type: 'dot',
        color: 'rgba(232, 236, 244, 0.92)',
      },
    });
  }, [size, url]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.innerHTML = '';
    qr.append(el);
    qr.update({ data: url, width: size, height: size });
  }, [qr, size, url]);

  return (
    <div className={`${st.root} ${className ?? ''}`}>
      <div className={st.canvas} ref={containerRef} />
    </div>
  );
}

